import { __decorate } from "tslib";
import { Vue, Component, Prop, Emit, Watch } from "vue-property-decorator";
import Avatar from '@/components/Avatar.vue';
let OngoingCallComponent = class OngoingCallComponent extends Vue {
    state;
    showRecallButton;
    phone;
    customer;
    get modalVariant() {
        let variant;
        switch (this.state) {
            case "failed":
                variant = 'danger';
                break;
            case "initializing":
                variant = 'warning';
                break;
            case "ongoing":
                variant = 'info';
                break;
            default:
                variant = 'info';
        }
        return variant;
    }
    get modalTitle() {
        let title;
        switch (this.state) {
            case "failed":
                title = 'Clinic has not accepted call';
                break;
            case "initializing":
                title = 'Waiting clinic to accept the call';
                break;
            case "ongoing":
                title = 'Call is started';
                break;
            default:
                title = 'Call';
        }
        return this.$t(title);
    }
    showPopover() {
        this.$bvToast.show('incoming-call-component');
    }
    hidePopover() {
        this.$bvToast.hide('incoming-call-component');
    }
    restartCall() {
        return true;
    }
    onStateChange(newState) {
        if (newState === 'ongoing') {
            setTimeout(this.hidePopover, 3000);
        }
    }
};
__decorate([
    Prop({ type: String, default: 'default' })
], OngoingCallComponent.prototype, "state", void 0);
__decorate([
    Prop({ type: Boolean, default: true })
], OngoingCallComponent.prototype, "showRecallButton", void 0);
__decorate([
    Prop({ type: String, required: true })
], OngoingCallComponent.prototype, "phone", void 0);
__decorate([
    Prop({ type: Object, required: true })
], OngoingCallComponent.prototype, "customer", void 0);
__decorate([
    Emit('recall')
], OngoingCallComponent.prototype, "restartCall", null);
__decorate([
    Watch('state')
], OngoingCallComponent.prototype, "onStateChange", null);
OngoingCallComponent = __decorate([
    Component({
        components: {
            Avatar,
        }
    })
], OngoingCallComponent);
export default OngoingCallComponent;
